import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export const api = {
  getConfig: () => client.get(`/config`).then((r) => r.data),
  listProfiles: () => client.get(`/profiles`).then((r) => r.data),
  createProfile: (data) => client.post(`/profiles`, data).then((r) => r.data),
  getProfile: (id) => client.get(`/profiles/${id}`).then((r) => r.data),
  nextQuestions: (data) => client.post(`/game/next-questions`, data).then((r) => r.data),
  submitRound: (data) => client.post(`/game/submit-round`, data).then((r) => r.data),
  getMastery: (id) => client.get(`/profiles/${id}/mastery`).then((r) => r.data),
  getSummary: (id) => client.get(`/profiles/${id}/summary`).then((r) => r.data),
  getQuests: (id) => client.get(`/profiles/${id}/quests`).then((r) => r.data),
  claimQuest: (id, qid) => client.post(`/profiles/${id}/quests/${qid}/claim`).then((r) => r.data),
  getShop: () => client.get(`/shop`).then((r) => r.data),
  buyCosmetic: (id, item_id) => client.post(`/profiles/${id}/buy`, { item_id }).then((r) => r.data),
  equipCosmetic: (id, item_id) => client.post(`/profiles/${id}/equip`, { item_id }).then((r) => r.data),
};
